import { AnimatePresence, motion } from 'framer-motion';
import { useState } from 'react';
import { OutlineChevronDownIcon, SolidCurrencyDollarIcon } from '@tempmee/react-icons';
import { colors } from '@tempmee/tailwind';
import { Center, Column, Row, Typography } from '@tempmee/react';
import { IJob } from '~/models';

interface IPreApprovedChargeTimelineBannerProps {
  job?: Partial<IJob> | null;
}

export const PreApprovedChargeTimelineBanner = ({
  job,
}: IPreApprovedChargeTimelineBannerProps) => {
  const [isOpen, setIsOpen] = useState(false);

  if (!job) {
    return null;
  }

  const { offer_owner: offerOwner } = job;

  // Check if office is pre-approved (invoiced)
  const isPreApproved = offerOwner?.is_pre_approved;

  // Only show if IS pre-approved
  if (!isPreApproved) {
    return null;
  }

  return (
    <Column style={{ margin: '20px 0px' }}>
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        style={{
          all: 'unset',
          width: '100%',
          backgroundColor: colors.success[30],
          border: `1px solid ${colors.success[600]}`,
          padding: '10px 12px',
          cursor: 'pointer',
          display: 'flex',
          flexDirection: 'column',
          gap: 8,
          boxSizing: 'border-box',
        }}
      >
        {/* Top row: Icon + Title + Arrow */}
        <Row align="center" justify="between">
          <Row align="center">
            <SolidCurrencyDollarIcon size={24} color={colors.success[500]} />
            <Typography as="span" variant="body1" bold color={colors.success[500]} style={{ marginLeft: 4 }}>
              Book Now, Pay Later!
            </Typography>
          </Row>
          <Center
            style={{
              transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
              transition: 'transform 0.3s ease',
            }}
          >
            <OutlineChevronDownIcon size={24} color={colors.success[500]} />
          </Center>
        </Row>
      </button>

      {/* Expanded content */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.2, ease: 'easeInOut' }}
            style={{
              overflow: 'hidden',
              backgroundColor: colors.success[30],
              border: `1px solid ${colors.success[600]}`,
              borderTopWidth: 0,
              padding: '0px 40px 12px 40px',
              marginTop: -1,
            }}
          >
            <Typography as="span" color={colors.success[500]}>
              Your office will be invoiced after the shift ends and time adjustments are settled.
            </Typography>
          </motion.div>
        )}
      </AnimatePresence>
    </Column>
  );
};
